
document.addEventListener("DOMContentLoaded", () => {

   /* =========================================
       FREE GIFT FEATURE FLAG

       false = gifts completely disabled
       true  = enable gifts later
    ========================================== */

    const ENABLE_FREE_GIFTS = false;
    /* =========================================
       CONFIG
    ========================================== */

    const container =
        document.getElementById("bundle-options");


    const giftContainer =
        document.getElementById("bundle-gifts");


    const oneTimeButton =
        document.getElementById("one-time-purchase");


    if (
        !container ||
        !window.bundleConfig ||
        !Array.isArray(window.bundleConfig.bundles) ||
        !window.bundleConfig.bundles.length
    ) {
        return;
    }



    /* =========================================
       LOCALIZATION
    ========================================== */

    const COUNTRY =
        window.storeLocalization?.country || "US";


    const CURRENCY =
        window.storeLocalization?.currency || "USD";



    /* =========================================
       GET LOCALIZED BUNDLE PRICE
    ========================================== */

    function getBundlePrice(bundle) {

        if (!bundle) {

            return {
                price: 0,
                compare: null
            };

        }


        return (
            bundle.prices?.[COUNTRY] ||
            bundle.prices?.US ||
            {
                price: bundle.price || 0,
                compare: bundle.compare || null
            }
        );

    }



    /* =========================================
       FORMAT MONEY
    ========================================== */

    function formatMoney(amount) {

        const number =
            Number(amount);


        if (
            amount === null ||
            amount === undefined ||
            Number.isNaN(number)
        ) {
            return "";
        }


        const decimals =
            Number.isInteger(number)
                ? 0
                : 2;



        /* =========================================
           AUSTRALIAN DOLLARS
           AUD$89
        ========================================== */

        if (CURRENCY === "AUD") {

            return `AUD$${number.toLocaleString(
                "en-AU",
                {
                    minimumFractionDigits:
                        decimals,

                    maximumFractionDigits:
                        2
                }
            )}`;

        }



        /* =========================================
           OTHER CURRENCIES
        ========================================== */

        try {

            return new Intl.NumberFormat(
                document.documentElement.lang ||
                "en-US",
                {
                    style:
                        "currency",

                    currency:
                        CURRENCY,

                    minimumFractionDigits:
                        decimals,

                    maximumFractionDigits:
                        2
                }
            ).format(number);

        }

        catch(error) {

            return `${CURRENCY} ${number}`;

        }

    }



    /* =========================================
       GIFT COMPARE PRICE
    ========================================== */

    function getGiftComparePrice(gift) {

        if (!gift) return null;


        return (
            gift.comparePrices?.[COUNTRY] ??
            gift.comparePrices?.US ??
            gift.comparePrice ??
            null
        );

    }



    /* =========================================
       CURRENT SELECTED BUNDLE
    ========================================== */

    let selected =
        window.bundleConfig.bundles[0];



    /* =========================================
       RENDER EVERYTHING
    ========================================== */

    function render() {

        renderBundles();

        renderGifts();

        bindBundleEvents();

        updateVariant();

        updateOneTimeButton();

        updateAtcButton();

        updateSubscriptionBenefitFrequency();

    }



    /* =========================================
       RENDER BUNDLE OPTIONS
    ========================================== */

    function renderBundles() {

        container.innerHTML = "";


        window.bundleConfig.bundles.forEach(
            bundle => {


                const active =
                    Number(bundle.id) ===
                    Number(selected.id);


                const pricing =
                    getBundlePrice(bundle);


                const days =
                    Number(bundle.days) || 1;


                /*
                 * LOCALIZED PRICE PER DAY
                 */

                const pricePerDay =
                    Number(pricing.price) /
                    days;


                container.insertAdjacentHTML(
                    "beforeend",
                    `

                    <div
                        class="
                            bundle-card
                            ${active ? "active" : ""}
                        "
                        data-id="${bundle.id}"
                    >


                        <div class="bundle-radio">

                            <span></span>

                        </div>



                        <div class="bundle-image">

                            <img
                                src="${bundle.image}"
                                alt="${stripHTML(bundle.title)}"
                                loading="lazy"
                            >

                        </div>



                        <div class="bundle-info">

                            <h3>
                                ${bundle.title}
                            </h3>

                            <p>
                                ${bundle.boxes}
                            </p>

                        </div>



                        <div class="bundle-price">


                            <div class="sleeq-bottle-unit">

                                <span>
                                    ${formatMoney(pricePerDay)}
                                </span>

                                <small>
                                    / day
                                </small>

                            </div>



                            <div class="bundle-price__total">


                                <span class="sleeq-total-label">
                                    Total
                                </span>


                                <strong>
                                    ${formatMoney(pricing.price)}
                                </strong>


                                ${
                                    pricing.compare
                                        ? `
                                            <del>
                                                ${formatMoney(pricing.compare)}
                                            </del>
                                        `
                                        : ""
                                }


                            </div>


                        </div>



                        ${
                            bundle.badge
                                ? `
                                    <div class="bundle-badge">
                                        ${bundle.badge}
                                    </div>
                                `
                                : ""
                        }


                    </div>

                    `
                );

            }
        );

    }



    /* =========================================
       RENDER GIFTS
    ========================================== */

  function renderGifts() {

    // Gifts are disabled for now.
    if (!ENABLE_FREE_GIFTS) {

        if (giftContainer) {
            giftContainer.innerHTML = "";
            giftContainer.style.display = "none";
        }

        return;
    }

    if (!giftContainer || !Array.isArray(selected.gifts)) {
        return;
    }

    giftContainer.style.display = "";
    giftContainer.innerHTML = "";

    selected.gifts.forEach(gift => {

        const locked =
            !gift.unlocked;

        const giftComparePrice =
            getGiftComparePrice(gift);

        giftContainer.insertAdjacentHTML(
            "beforeend",
            `
            <div
                class="
                    bundle-gift
                    ${
                        locked
                            ? "bundle-gift--locked"
                            : "bundle-gift--unlocked"
                    }
                "
            >

                <div class="bundle-gift__price-tag">

                    <strong>
                        FREE
                    </strong>

                    ${
                        giftComparePrice
                            ? `
                                <del>
                                    ${formatMoney(giftComparePrice)}
                                </del>
                            `
                            : ""
                    }

                </div>

                <div class="bundle-gift__image">

                    <img
                        src="${gift.image}"
                        alt="${gift.title}"
                        loading="lazy"
                    >

                    ${
                        locked
                            ? `
                                <div class="bundle-gift__locked-overlay">
                                    <span>
                                        Locked
                                    </span>
                                </div>
                            `
                            : ""
                    }

                </div>

                <div class="bundle-gift__title">
                    ${gift.title}
                </div>

            </div>
            `
        );

    });

}


    /* =========================================
       BUNDLE CLICK EVENTS
    ========================================== */

    function bindBundleEvents() {

        document
            .querySelectorAll(
                ".bundle-card"
            )
            .forEach(card => {


                card.addEventListener(
                    "click",
                    () => {


                        const bundle =
                            window.bundleConfig
                                .bundles
                                .find(
                                    item =>
                                        Number(item.id) ===
                                        Number(card.dataset.id)
                                );


                        if (!bundle) {
                            return;
                        }


                        selected =
                            bundle;


                        render();

                    }
                );

            });

    }



    /* =========================================
       UPDATE VARIANT + SELLING PLAN
    ========================================== */

    function updateVariant() {

        const input =
            document.querySelector(
                "input.product-variant-id"
            );


        if (!input) {

            console.warn(
                "Bundle selector: product variant input not found."
            );

            return;

        }


        input.value =
            selected.variantId;


        const form =
            input.closest(
                "form"
            );


        if (!form) {
            return;
        }


        let sellingPlanInput =
            form.querySelector(
                'input[name="selling_plan"]'
            );


        if (!sellingPlanInput) {

            sellingPlanInput =
                document.createElement(
                    "input"
                );


            sellingPlanInput.type =
                "hidden";


            sellingPlanInput.name =
                "selling_plan";


            input.insertAdjacentElement(
                "afterend",
                sellingPlanInput
            );

        }


        sellingPlanInput.value =
            selected.selling_plan || "";


        input.dispatchEvent(
            new Event(
                "change",
                {
                    bubbles: true
                }
            )
        );

    }



    /* =========================================
       UPDATE SUBSCRIPTION BENEFIT TEXT
    ========================================== */

    function updateSubscriptionBenefitFrequency() {

        const firstItem =
            document.querySelector(
                ".subscription-benefits .subscription-benefits__item:first-child span"
            );


        if (!firstItem) {
            return;
        }


        firstItem.textContent =
            selected.frequency;

    }



    /* =========================================
       UPDATE MAIN ATC
    ========================================== */

    function updateAtcButton() {

        const button =
            document.querySelector(
                ".main-product-atc"
            );


        if (!button) {
            return;
        }


        const label =
            button.querySelector(
                ".button__label"
            );


        if (!label) {
            return;
        }


        const pricing =
            getBundlePrice(
                selected
            );


        label.textContent =
            `ADD TO CART - ${formatMoney(pricing.price)}`;

    }



    /* =========================================
       UPDATE ONE-TIME BUTTON
    ========================================== */


async function updateOneTimeButton() {
    console.log("updating one time");

    if (!oneTimeButton) {
        console.log("no one time btn");
        return;
    }

    if (!selected?.variantId) {
        console.log("no selected variant");
        return;
    }

    try {
        const productHandle = "4-in-hair-growth-serum";
        const root = window.Shopify?.routes?.root || "/";

        const response = await fetch(
            `${root}products/${productHandle}.js`
        );

        if (!response.ok) {
            throw new Error("Failed to fetch product");
        }

        const product = await response.json();

        const variant = product.variants.find(
            item =>
                Number(item.id) ===
                Number(selected.variantId)
        );

        if (!variant) {
            console.log("Variant not found:", selected.variantId);
            return;
        }

        const price = Number(variant.price) / 100;

        oneTimeButton.textContent =
            `ONE-TIME PURCHASE - ${formatMoney(price)}`;

    } catch (error) {
        console.error("Error updating one-time button:", error);
    }
}




    /* =========================================
       BUILD CART ITEMS
    ========================================== */

    function buildCartItems(
        subscription = true
    ) {

        const items = [];


        const mainItem = {

            id:
                Number(
                    selected.variantId
                ),

            quantity:
                1

        };


        /*
         * SELLING PLAN ONLY FOR
         * SUBSCRIPTION
         */

        if (
            subscription &&
            selected.selling_plan
        ) {

            mainItem.selling_plan =
                Number(
                    selected.selling_plan
                );

        }


        mainItem.properties = {

            "_bundle_id":
                String(
                    selected.id
                ),

            "_bundle_type":
                subscription
                    ? "subscription"
                    : "one-time"

        };


        items.push(
            mainItem
        );



        /* =========================================
           GIFTS
        ========================================== */

     if (
    ENABLE_FREE_GIFTS &&
    Array.isArray(
        selected.gifts
    )
) {

            selected.gifts

                .filter(
                    gift =>
                        gift.unlocked &&
                        gift.variantId
                )

                .forEach(
                    gift => {

                        items.push({

                            id:
                                Number(
                                    gift.variantId
                                ),

                            quantity:
                                1,

                            properties: {

                                "_bundle_gift":
                                    "true",

                                "_bundle_id":
                                    String(
                                        selected.id
                                    )

                            }

                        });

                    }
                );

        }


        return items;

    }



    /* =========================================
       ADD BUNDLE TO CART
    ========================================== */

    async function addSelectedBundleToCart({
        subscription = true
    } = {}) {


        const items =
            buildCartItems(
                subscription
            );


        const response =
            await fetch(

                `${
                    window.Shopify
                        ?.routes
                        ?.root || "/"
                }cart/add.js`,

                {

                    method:
                        "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify({
                            items
                        })

                }

            );


        const data =
            await response.json();


        if (!response.ok) {

            console.error(
                "Bundle cart error:",
                data
            );


            throw new Error(
                data.description ||
                data.message ||
                "Unable to add bundle to cart."
            );

        }


        return data;

    }



    /* =========================================
       ONE TIME PURCHASE
    ========================================== */

    async function oneTimePurchase() {

        if (!oneTimeButton) {
            return;
        }


        setButtonLoading(
            oneTimeButton,
            true
        );


        try {


            const includeGiftsForOneTime =
                ENABLE_FREE_GIFTS;


            if (
                includeGiftsForOneTime
            ) {

                await addSelectedBundleToCart({
                    subscription:
                        false
                });

            }

            else {

                await addSingleMainProduct(
                    false
                );

            }


            window.location.href =
                "/checkout";

        }

        catch(error) {

            console.error(
                error
            );


            alert(
                error.message ||
                "Unable to add product to cart."
            );

        }

        finally {

            setButtonLoading(
                oneTimeButton,
                false
            );

        }

    }



    /* =========================================
       MAIN SUBSCRIPTION ATC
    ========================================== */

    function setupMainAtc() {

        const button =
            document.querySelector(
                ".main-product-atc"
            );


        if (!button) {

            console.warn(
                "Bundle selector: .main-product-atc not found."
            );

            return;

        }


        button.addEventListener(
            "click",

            async event => {


                event.preventDefault();

                event.stopPropagation();

                event.stopImmediatePropagation();


                if (
                    button.disabled ||
                    button.dataset.bundleLoading ===
                    "true"
                ) {
                    return;
                }


                button.dataset.bundleLoading =
                    "true";


                button.disabled =
                    true;


                button.classList.add(
                    "is-loading"
                );


                try {

                    await addSelectedBundleToCart({
                        subscription:
                            true
                    });


                    window.location.href =
                        "/checkout";

                }

                catch(error) {

                    console.error(
                        "Subscription bundle error:",
                        error
                    );


                    alert(
                        error.message ||
                        "Unable to add bundle to cart."
                    );

                }

                finally {

                    button.dataset.bundleLoading =
                        "false";


                    button.disabled =
                        false;


                    button.classList.remove(
                        "is-loading"
                    );

                }

            },

            true
        );

    }



    /* =========================================
       SINGLE PRODUCT HELPER
    ========================================== */

    async function addSingleMainProduct(
        subscription = false
    ) {

        const item = {

            id:
                Number(
                    selected.variantId
                ),

            quantity:
                1

        };


        if (
            subscription &&
            selected.selling_plan
        ) {

            item.selling_plan =
                Number(
                    selected.selling_plan
                );

        }


        const response =
            await fetch(

                `${
                    window.Shopify
                        ?.routes
                        ?.root || "/"
                }cart/add.js`,

                {

                    method:
                        "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify({
                            items: [item]
                        })

                }

            );


        const data =
            await response.json();


        if (!response.ok) {

            throw new Error(
                data.description ||
                data.message ||
                "Unable to add product."
            );

        }


        return data;

    }



    /* =========================================
       BUTTON LOADING
    ========================================== */

    function setButtonLoading(
        button,
        loading
    ) {

        if (!button) {
            return;
        }


        if (loading) {

            button.disabled =
                true;


            button.dataset.originalText =
                button.textContent;


            button.textContent =
                "ADDING...";


            button.classList.add(
                "is-loading"
            );

        }

        else {

            button.disabled =
                false;


            if (
                button.dataset.originalText
            ) {

                button.textContent =
                    button.dataset.originalText;

            }


            button.classList.remove(
                "is-loading"
            );

        }

    }



    /* =========================================
       STRIP HTML
    ========================================== */

    function stripHTML(
        value = ""
    ) {

        const div =
            document.createElement(
                "div"
            );


        div.innerHTML =
            value;


        return (
            div.textContent ||
            div.innerText ||
            ""
        );

    }



    /* =========================================
       ONE TIME BUTTON EVENT
    ========================================== */

    if (oneTimeButton) {

        oneTimeButton.addEventListener(
            "click",

            event => {

                event.preventDefault();

                oneTimePurchase();

            }
        );

    }



    /* =========================================
       INITIALIZE
    ========================================== */

    render();

    setupMainAtc();


});

